import * as React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { IA2AccountDropdownTrigger } from './components/AccountDropdown/IA2AccountDropdownTrigger';
import { PAGE_LAYOUT_TYPE, selectPageLayoutType } from 'src/app/slice';
import { showInternalView } from 'src/commons/utils/helpers';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

const MobileAccountSwitcherSectionContainer = styled.div<{
  pageLayoutType: PAGE_LAYOUT_TYPE;
}>`
  background-color: ${({ theme, pageLayoutType }) =>
    theme.header.contextBar[pageLayoutType]?.backgroundColor ||
    theme.header.contextBar[PAGE_LAYOUT_TYPE.STANDARD].backgroundColor};
  padding: ${({ theme }) =>
    `${theme.spacing.xxxxsmall.mobile} ${theme.spacing.xsmall.mobile} ${theme.spacing.xxsmall.mobile}`};
`;

interface MobileAccountSwitcherSectionProps {
  handleToggle: () => void;
}

export const MobileAccountSwitcherSection: React.FC<
  MobileAccountSwitcherSectionProps
> = ({ handleToggle }) => {
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const { isInternalView } = internalChromeConfig;
  const pageLayoutType = useSelector(selectPageLayoutType);

  return (
    <MobileAccountSwitcherSectionContainer
      pageLayoutType={
        showInternalView(pageLayoutType, isInternalView)
          ? PAGE_LAYOUT_TYPE.INTERNAL_STANDARD
          : pageLayoutType
      }
    >
      <IA2AccountDropdownTrigger handleToggle={handleToggle} isOpen={false} />
    </MobileAccountSwitcherSectionContainer>
  );
};
